import { modals } from '@mantine/modals'

import AssignTaskModalComponent, {
  type ModalProps,
} from '../components/TaskModal/assignTaskModal.component'

export const openAssignTaskModal = (props: ModalProps) => {
  return modals.open({
    centered: true,
    id: 'example',
    size: 'xl',
    withCloseButton: true,
    children: <AssignTaskModalComponent {...props} />,
  })
}
